import React from 'react';
import FormField from '../../../../components/FormField';
import { FIELD_SELECT, EXP_MONTHS } from '../../../../constants';
import { formatCreditCard } from '../../helpers';

const CreditCardInput = ({ formikBag, className }) => {
  
  const year = new Date().getFullYear();
  const yearArr = Array.from({length: 10}, (_, i) => i + parseInt(year));

  return (
    <div className={className}>
      <div className="row">
        <div className="col">
          <FormField
            name="cardNumber"
            formikBag={formikBag}
            label="Card Number"
            formatValue={formatCreditCard}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormField
            name="cardMonth"
            fieldType={FIELD_SELECT}
            formikBag={formikBag}
            label="Expiry Month"
            options={EXP_MONTHS}
          />
        </div>
        <div className="col">
          <FormField
            name="cardYear"
            fieldType={FIELD_SELECT}
            formikBag={formikBag}
            label="Expiry Year"
            options={yearArr.map(y => { return {label: `${y}`, value: y}; })}
          />
        </div>
        <div className="col">
          <FormField
            name="cardCVC"
            formikBag={formikBag}
            label="CVC"
          />
        </div>
      </div>
    </div>
  );
}

export default CreditCardInput;
